@if (label()) {
  <label [for]="id()" class="block text-sm font-medium mb-1" style="color:var(--talos-ink)">
    {{ labelText() }}@if (isRequired()) {<span class="text-talos-accent ml-0.5">*</span>}
  </label>
}
<div class="relative flex items-center">
  @if (leadingIcon()) {
    <span class="absolute left-3 flex items-center pointer-events-none">
      <lucide-icon [img]="leadingIcon()!" [size]="16" color="var(--talos-accent, var(--talos-accent))"></lucide-icon>
    </span>
  }
  <input
    [id]="id()"
    [type]="inputType()"
    class="w-full border bg-[var(--talos-bg)] focus:outline-none transition-colors"
    style="color:var(--talos-ink)"
    [class.rounded]="size() === 'md'"
    [class.rounded]="size() === 'sm'"
    [class.py-3]="size() === 'md'"
    [class.text-sm]="size() === 'md'"
    [class.py-1.5]="size() === 'sm'"
    [class.text-xs]="size() === 'sm'"
    [class.border-talos-ink/18]="!invalid()"
    [style.border-color]="invalid() ? 'var(--talos-accent)' : null"
    [style.box-shadow]="'0 0 0 0'"
    [class.focus:border-talos-ink/50]="!invalid()"
    [class.pl-10]="hasLeadingIcon()"
    [class.pl-3]="!hasLeadingIcon()"
    [class.pr-10]="type() === 'password'"
    [class.pr-3]="type() !== 'password'"
    [placeholder]="placeholder()"
    [value]="value()"
    [disabled]="isDisabled()"
    [attr.inputmode]="inputMode()"
    [attr.pattern]="inputPattern()"
    [attr.maxlength]="maxLength()"
    [attr.min]="min()"
    [attr.max]="max()"
    [attr.step]="step()"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />
  @if (type() === 'password') {
    <button type="button" class="absolute right-3 flex items-center bg-transparent border-0 cursor-pointer p-0 transition-colors" (click)="togglePassword()">
      <lucide-icon [img]="showPassword() ? EyeOffIcon : EyeIcon" [size]="16" color="var(--talos-accent, var(--talos-accent))"></lucide-icon>
    </button>
  }
</div>
@if (hint() && !invalid()) {
  <span class="block text-xs mt-1" style="color:rgb(var(--talos-ink-rgb) / 0.4)">{{ hint() }}</span>
}
@if (invalid() && errorMessage()) {
  <app-field-message type="error" [message]="errorMessage()" />
}
